export class AdditionalData {
  constructor(public data: any) {
  }
}
